// Types for our modal content
interface ModalContent {
  isOpen: boolean;
  currentIndex: number | null;
}

// Modal content state management
class OptionModal {
  private modal: ModalContent = {
    isOpen: false,
    currentIndex: null,
  };

  private readonly modalContentClass = 'p-optionBodyPopContent';
  private readonly modalCloseClass = 'p-optionBodyPopClose';
  private readonly activeClass = 'is-active';
  private readonly showClass = 'is-show';
  private readonly animationDuration = 400; // milliseconds - should match CSS

  constructor() {
    this.initialize();
  }

  private initialize(): void {
    // Add click event listeners to list items
    const listItems = document.querySelectorAll('.p-optionBodyListItem');
    listItems.forEach((item, index) => {
      item.addEventListener('click', () => this.openModal(index));
    });

    // Add close button event listener
    const closeButtons = document.querySelectorAll(`.${this.modalCloseClass}`);
    closeButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.stopPropagation();
        this.closeModal();
      });
    });

    // Add escape key event listener
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.closeModal();
      }
    });

    // Add click outside modal event listener
    document.addEventListener('click', (event) => {
      const target = event.target as HTMLElement;
      if (target.classList.contains(this.modalContentClass)) {
        this.closeModal();
      }
    });
  }

  private openModal(index: number): void {
    if (this.modal.isOpen) return;

    const modalContent = document.querySelectorAll(
      `.${this.modalContentClass}`
    );
    if (!modalContent[index]) return;

    this.modal.isOpen = true;
    this.modal.currentIndex = index;

    const element = modalContent[index] as HTMLElement;
    element.classList.add(this.activeClass);
    document.body.style.overflow = 'hidden';

    // Add show class after a small delay to trigger animation
    requestAnimationFrame(() => {
      element.classList.add(this.showClass);
    });
  }

  private closeModal(): void {
    if (!this.modal.isOpen || this.modal.currentIndex === null) return;

    const modalContent = document.querySelectorAll(
      `.${this.modalContentClass}`
    );
    const element = modalContent[this.modal.currentIndex] as HTMLElement;

    // Remove show class first to trigger fade out
    element.classList.remove(this.showClass);

    // Wait for animation to complete before removing active class
    setTimeout(() => {
      element.classList.remove(this.activeClass);
      document.body.style.overflow = '';
      this.modal.isOpen = false;
      this.modal.currentIndex = null;
    }, this.animationDuration);
  }
}

// Initialize the modal functionality when the DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new OptionModal();
});
